import { dashboardReservationsSelector } from '../selectors'
import WaitingListRecord from './WaitingListRecord'
import { createStructuredSelector } from 'reselect'

import classNames from 'classnames'
import styles from './styles.module.scss'

const Header = () => (
    <div className={styles.tableHeader}>
        <div className={styles.joinDate}>
            <T>dashboard.label.joinDate</T>
        </div>
        <div className={styles.type}>
            <T>dashboard.label.type</T>
        </div>
        <div className={styles.location}>
            <T>dashboard.label.location</T>
        </div>
        <div className={styles.book}>
            <T>dashboard.label.book</T>
        </div>
        <div className={styles.dueDate}>
            <T>dashboard.label.dueDate</T>
        </div>
        <div className={styles.actions} />
    </div>
)

const WaitingListTable = ({ reservations }) => (
    <div className={classNames('table', 'table-hover', 'mt-4', styles.table, styles.waitingList)}>
        <Header />
        {reservations.map(id => (
            <WaitingListRecord reservationId={id} key={id} />
        ))}
    </div>
)

export default connect(
    createStructuredSelector({
        reservations: dashboardReservationsSelector,
    })
)(WaitingListTable)
